import { render, staticRenderFns } from "./InformationList.vue?vue&type=template&id=7ce9c07b&scoped=true"
import script from "./InformationList.vue?vue&type=script&lang=js"
export * from "./InformationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce9c07b",
  null
  
)

export default component.exports